import Vue from 'vue'
import Badges from './Badges'
import { ModerationStages } from '@/constants/backend/ModerationStages'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import rolebleMixin from '@/mixins/rolebleMixin'
import MyGigApplication from '@/models-ts/gigs/MyGigApplication'

export default Vue.extend({
  mixins: [rolebleMixin],
  props: {
    application: MyGigApplication,
  },
  computed: {
    badge() {
      const app = this.application
      if ([ModerationStages.PREMODERATION, ModerationStages.MANUAL].includes(app.moderationStage)) return Badges.Moderation
      if (app.moderationStage === ModerationStages.FAILED) return Badges.Declined

      const offer = app.offer
      if (!offer) return Badges.OfferRequested
      if (offer?.stage === GigOfferStages.NEW) {
        return this.isCustomer ? Badges.OfferReceived : Badges.OfferSent
      }
      if ([GigOfferStages.DECLINED_BY_CUSTOMER, GigOfferStages.DECLINED_BY_FREELANCER].includes(offer.stage)) {
        return Badges.OfferDeclined
      }
      if ([GigOfferStages.ACCEPTED_BY_CUSTOMER, GigOfferStages.ACCEPTED_BY_FREELANCER].includes(offer.stage)) {
        return Badges.OfferAccepted
      }
    },
  },
})
